import React, { Component } from "react";
import styled from "styled-components";

import { Row } from "./box";
import { Img } from "./image";

const IconWrapper = styled(Row)`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: 50%;
  background: ${({ color }) => color};
  align-items:center;
  justify-content:center;
`;

export default ({ width, height, icon, color }) => {
  return (
    <IconWrapper width={width} height={height} color={color}>
      <Img width="50%" height="50%" src={icon} />
    </IconWrapper>
  );
};
